export default __webpack_public_path__ + "static/media/vrcontroller.1d8f3321.png";